import React, { useMemo, useState } from "react";
import jwt_decode from "jwt-decode";
import { TableInvoicePCF, TablePCFOri, TableSubmitPCFRevisi } from "./TableSubmitPCF";
import AxiosLibWithHeader2 from "../../../../../../Library/AxiosLibWithHeader2";
import { openModal } from "../../../../../../Library/ModalPopUp";
import { openToast } from "../../../../../../Library/ToastPopUp";

var AuthToken = localStorage.getItem("AuthToken");
const AuthDecode = AuthToken ? jwt_decode(AuthToken) : [];

export default function PreviewPCFRevision({
  myprev,
  data,
  fpcf,
  originPCFRev,
  finish,
  eventid,
  student,
  studentid,
}) {

  const total_ori_pcf = useMemo(() => {
    let total = 0;
    const objSubjectUniq = originPCFRev.reduce((accumulator, currentValue) => {
      if (currentValue.detail && currentValue.detail.hasOwnProperty('not_billed') && currentValue.detail.not_billed === 0) {
        const { course_id, detail: { course_credit } } = currentValue;
        if (!accumulator.hasOwnProperty(course_id)) {
          accumulator[course_id] = course_credit;
        } else if (accumulator[course_id] !== course_credit) {
          accumulator[course_id] += course_credit;
        }
      }
      return accumulator;
    }, {});

    console.log(originPCFRev);
    console.log(objSubjectUniq);

    if (objSubjectUniq) {
      Object.keys(objSubjectUniq).map((k) => {
        total = total + objSubjectUniq[k];
      });
    }
    return total;
  }, [originPCFRev])


  const total_rev_pcf = useMemo(() => {
    let total = 0;
    const objSubjectUniq = data.reduce((accumulator, currentValue) => {
      if (currentValue.action_type === "add" && currentValue.detail && currentValue.detail.hasOwnProperty('not_billed') && currentValue.detail.not_billed === 0) {
        const { course_id, detail: { course_credit } } = currentValue;
        if (!accumulator.hasOwnProperty(course_id)) {
          accumulator[course_id] = course_credit;
        } else if (accumulator[course_id] !== course_credit) {
          accumulator[course_id] += course_credit;
        }
      }
      return accumulator;
    }, {});

    if (objSubjectUniq) {
      Object.keys(objSubjectUniq).map((k) => {
        total = total + objSubjectUniq[k];
      });
    }
    return total;
  }, [data])


  const HandlerApprove = () => {
    if (AuthDecode.remotedBy) {
      openToast({ header: "Error", message: "You cannot access this request" });
      openModal({ open: false });
    } else {
      var originpcf = [...fpcf];
      var result = data.filter(
        (a) =>
          originpcf.some(
            (a1) =>
              a1.section_id === a.section_id && a.action_type !== a1.action_type
          ) || originpcf.every((a1) => a1.section_id !== a.section_id)
      );
      var krslines = result.map((v) => {
        var item = {};
        if (v.detail.krsline_id) {
          item.id = v.detail.krsline_id;
        }
        item.action_type = v.action_type;
        item.course_id = v.course_id;
        item.section_id = v.section_id;
        return item;
      });
      var param = {
        eventid: eventid,
        krslines: krslines,
      };

      UPDATE_COUNSELING_PCF(
        param,
        eventid,
        setUpdatePCF,
        setApprovePCF,
        studentid
      );
    }
  };

  const [updatePCF, setUpdatePCF] = useState({
    loading: false,
    data: [],
    message: "",
  });
  const [approvePCF, setApprovePCF] = useState({
    loading: false,
    data: [],
    message: "",
  });

  return (
    <div className="preview-pcf">
      <div className="row">
        <div className="col-8">
          <div className="table-pcf">
            <div style={{ overflowY: "auto", overflowX: "hidden", maxHeight: "450px" }} className="px-3">
              <div className="row">
                <div className="col-6">
                  <div className="card">
                    <div className="card-body p-0">
                      <h3 className="text-center">PCF Original</h3>
                      <TablePCFOri pcffirst={originPCFRev} totalFPCF={total_ori_pcf} />
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="card">
                    <div className="card-body p-0">
                      <h3 className="text-center">PCF Revision</h3>
                      <TableSubmitPCFRevisi
                        pcffirst={originPCFRev}
                        mypcf={data}
                        totalsks={total_rev_pcf}
                        invoice={myprev}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-4">
          {myprev.totalAmount ? (
            <TableInvoicePCF
              invoice={myprev}
              approvePCF={approvePCF}
              updatePCF={updatePCF}
              HandlerApprove={HandlerApprove}
            />
          ) : (
            <div className="mt-8">
              <button
                className="btn btn-block btn-sm btn-primary text-uppercase p-3 font-weight-bold"
                type="button"
                onClick={() => HandlerApprove()}
                disabled={approvePCF.loading}
              >
                {approvePCF.loading || updatePCF.loading
                  ? "Processing..."
                  : "Approve PCF"}
              </button>
              <button
                className="btn btn-block btn-sm btn-light text-uppercase p-3 font-weight-bold"
                type="button"
                onClick={() => openModal({ open: false })}
              >
                Cancel
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

const UPDATE_COUNSELING_PCF = (
  parameters,
  eventid,
  setUpdatePCF,
  setApprovePCF,
  studentid
) => {
  setUpdatePCF({ loading: true, data: [], message: "" });
  setApprovePCF({ loading: true, data: [], message: "" });
  var keys = {
    AppId: AuthDecode.AppID,
    AppEnv: AuthDecode.AppEnv,
    Secretkey: AuthDecode.secretkey,
  };
  var body = {
    parameters: parameters,
    target_data: "UPDATE_COUNSELING_PCF",
  };
  const postData = {
    keys: keys,
    body: body,
  };

  AxiosLibWithHeader2(postData, "app/api/req-module").then((response) => {
    if (response.error) {
      openModal({ open: false });
      setUpdatePCF({ loading: false, message: response.error, data: [] });
      openToast({ header: "Error", message: response.error });
    } else if ("message" in response.response) {
      openModal({ open: false });
      var msg = response.response.message.internal;
      setUpdatePCF({ loading: false, message: msg, data: [] });
      openToast({ header: "Information", message: msg });
    } else {
      var param = response.response.data;
      setUpdatePCF({
        data: param,
        loading: false,
        message: "Successfully approve ",
      });
      PROCESS_COUNSELING_PCF(eventid, setApprovePCF, studentid);
    }
  });
};
const PROCESS_COUNSELING_PCF = (eventid, setApprovePCF, studentid) => {
  setApprovePCF({ loading: true, data: [], message: "" });
  var keys = {
    AppId: AuthDecode.AppID,
    AppEnv: AuthDecode.AppEnv,
    Secretkey: AuthDecode.secretkey,
  };

  var param = {
    eventid: eventid,
  };

  var body = {
    parameters: param,
    target_data: "PROCESS_COUNSELING_PCF",
  };

  const postData = {
    keys: keys,
    body: body,
  };

  AxiosLibWithHeader2(postData, "app/api/req-module").then((response) => {
    //console.log("Approve PCF", response);
    if ("message" in response.response) {
      openModal({ open: false });
      setApprovePCF({
        loading: false,
        data: [],
        message: response.response.message.user,
      });
      openToast({
        message: response.response.message.user,
        header: "Info",
      });
    } else {
      var result = response.response.result;
      if (result === "success") {
        openModal({ open: false });
        setApprovePCF({
          loading: false,
          data: response.response.data,
          message: "Succsessfully updated and approved the PCF",
        });
        openToast({
          message:
            "Succsessfully updated and approved the PCF. Wait for a moment...",
          header: "Info",
        });
        setTimeout(() => {
          window.location.href =
            "/counseling/student/" + studentid + "/activity";
        }, 1500);
      } else {
        openModal({ open: false });
        setApprovePCF({
          loading: false,
          data: [],
          message: "Failed approve the PCF." + response.response.msg,
        });
        openToast({
          message: response.response.msg,
          header: "Error",
        });
      }
    }
  });
};
